export * from './account.module';
export * from './account.route';
export * from './authentication/authentication.route';
export * from './register/register.route';
export * from './password-reset/init/password-reset-init.route';
export * from './settings/settings.route';
export * from './register/register.service';



// WEBPACK FOOTER //
// ./src/main/webapp/app/account/index.ts